<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import getQueryString from "@tools/getQueryString";
import storage from "@/tools/storage";
export default {
  mounted() {
    // 取消开始的loading动画
    const preLoader = document.querySelector("#pre-loader");
    preLoader.style.display = "none";
    document.body.ondrop = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
  },
  created() {
    this.parseToken();
  },
  methods: {
    parseToken() {
      let token = getQueryString("token");
      // console.log(token);
      if (token) {
        storage.set("logininfo", {
          token: token,
        });
      }
    },
  },
};
</script>
